import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryElectricityIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-electricity"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M8.14303 7.66244H7.89526C7.51839 7.66244 7.21021 7.35406 7.21021 6.97739V2.72527C7.21021 2.3485 7.51839 2.04022 7.89526 2.04022H8.14303C8.5197 2.04022 8.82808 2.3485 8.82808 2.72527V6.97739C8.82808 7.35406 8.5197 7.66244 8.14303 7.66244Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M15.5854 7.62222H15.3376C14.9608 7.62222 14.6526 7.31394 14.6526 6.93717V2.68505C14.6526 2.30828 14.9608 2 15.3376 2H15.5854C15.9621 2 16.2704 2.30828 16.2704 2.68505V6.93717C16.2704 7.31394 15.9621 7.62222 15.5854 7.62222Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M8.76092 19.0007C8.40162 19.0088 8.10607 18.7198 8.10607 18.3603V16.6711C8.10607 16.6711 8.21294 15.7798 6.67991 14.853C5.14698 13.926 4.50526 12.7852 4.50526 12.7852C4.50526 12.7852 3.93486 10.7531 4.00617 8.11488C4.00617 8.11488 4.11304 7.08104 5.2896 7.04539C6.46607 7.00973 18.3022 7.04539 18.3022 7.04539C18.3022 7.04539 19.4435 6.98549 19.4806 8.13498V11.2373C19.4806 11.2373 19.2987 14.16 16.7479 14.9092C16.7479 14.9092 15.2138 15.3908 15.2494 17.6385L15.258 18.2319C15.2631 18.5891 14.975 18.8814 14.6175 18.8814H14.2218C14.0505 18.8814 13.9116 19.0203 13.9116 19.1917V21.4826C13.9116 21.7634 13.6839 21.9909 13.4032 21.9909H10.2579C9.9794 21.9909 9.75274 21.7669 9.7496 21.4884L9.72435 19.2928C9.72233 19.1201 9.57971 18.9823 9.40718 18.9861L8.76092 19.0007Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M13.4722 11.4323L12.0346 11.6593L13.0045 9.96026C13.0663 9.85703 12.9838 9.72642 12.86 9.73329L10.9546 9.89834C10.8928 9.90531 10.8446 9.94652 10.8239 10.0016L9.84035 13.0762C9.80591 13.1863 9.90217 13.2896 10.0123 13.2689L11.0096 13.0832L10.1498 16.0754C10.1017 16.2405 10.3219 16.3436 10.4181 16.206L13.6167 11.6731C13.6992 11.563 13.6029 11.4117 13.4722 11.4323Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryElectricityIcon.displayName = 'CategoryElectricityIcon';
